import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import EditIcon from "@mui/icons-material/Edit";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import HotelIcon from "@mui/icons-material/Hotel";
import RepeatIcon from "@mui/icons-material/Repeat";
import Typography from "@mui/material/Typography";
import Iconify from "../Dashboard/Iconify";
import { colors } from "../../Styles/GlobalStyles/Variables";
import { useSelector } from "react-redux";
const getActivityState = (state) => state.activityReducer;

export default function CustomizedTimeline() {
  const { userActivity } = useSelector(getActivityState);
  const sortedActivity = userActivity?.reverse();

  console.log(sortedActivity, "sorted");
  return (
    <Timeline
      sx={{
        padding: 0,
        mt: 3,
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      {sortedActivity?.map((activity, index) => {
        const pattern = /(\d+ \w+ ago)$/;
        const match = activity?.match(pattern);
        const deletedPattern = /^(.*)\s\d+ \w+ ago$/; // Regular Expression pattern to match the entire string up to the time part
        const trimmedText = activity?.match(deletedPattern);
        return (
          <TimelineItem key={index}>
            <TimelineSeparator>
              <TimelineDot
                sx={{
                  margin: 0,
                  padding: 1,
                  boxShadow: "none",
                  bgcolor: activity?.includes("created")
                    ? "#d8ece3"
                    : activity?.includes("updated")
                    ? "#eeeacf"
                    : activity?.includes("payment")
                    ? "#dee9f7"
                    : activity?.includes("corp member to loan")
                    ? "#ebf1fc"
                    :"pink",
                }}
              >
                {activity?.includes("created") ? (
                  <Iconify
                    icon="bi:magic"
                    width={16}
                    height={16}
                    color={colors.primaryGreen}
                  />
                ) : activity?.includes("updated") ? (
                  <Iconify
                    icon="mdi:text-box-edit"
                    width={16}
                    height={16}
                    color={colors.primaryYellow}
                  />
                ) : activity?.includes("payment") ? (
                  <Iconify
                    icon="fluent:payment-20-filled"
                    width={16}
                    height={16}
                    color={colors.lightblue}
                  />
                ) : activity?.includes("corp member to loan") ? (
                  <Iconify
                    icon="majesticons:document-award"
                    width={16}
                    height={16}
                    color="#7899D9"
                  />
                ):<Iconify icon="carbon:task-complete" width={16} height={16} color ={colors.lightRed}/>}
              </TimelineDot>
              <TimelineConnector sx={{ width: "0.4px", padding: "0px" }} />
            </TimelineSeparator>
            <TimelineContent
              sx={{ py: "0px", px: 2, paddingTop: "0px !important" }}
            >
             {activity!==null && activity.length!==0?<>
              <Typography sx={{ padding: 0 }} variant="body2" component="span">
                {/* {match[1]} */}
              </Typography>
              {/* <Typography sx={{ padding: 0 }}>{trimmedText[1]}</Typography> */}
             </>:""}
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
}
